import { render, staticRenderFns } from "./JobsEmpty.vue?vue&type=template&id=24f4a472&"
import script from "./JobsEmpty.vue?vue&type=script&lang=js&"
export * from "./JobsEmpty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports